import {ModeEnum, MODES} from '@/utils/consts'
import { DateTime } from 'luxon'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  mode: MODES[0],
  site: null,
  sector: null,
  customer: null,
  meshSite: null,
  periods: {
    [ModeEnum.RELIABILITY]: DateTime.local().toISODate(),
    [ModeEnum.QUALITY]: DateTime.local().toISODate(),
    [ModeEnum.MESH_QUALITY]: DateTime.local().toISODate(),
    [ModeEnum.LEFTBEHIND]: DateTime.local().plus({ days: -1 }).toISODate()
  }
}

const mutations = {
  SET_MODE(state, mode) {
    state.mode = mode
  },

  SET_SITE(state, site) {
    state.site = site
  },

  SET_MESH_SITE(state, customer) {
    state.meshSite = customer
  },

  SET_SECTOR(state, sector) {
    state.sector = sector
  },

  SET_CUSTOMER(state, customer) {
    state.customer = customer
  },

  SET_PERIOD(state, period) {
    state.periods[state.mode] = period
  },

  INIT_CONTEXT() {
    const storedContext = JSON.parse(localStorage.getItem('supply.context'))
    if (storedContext) {
      state.mode = storedContext.mode
      state.site = storedContext.site
      state.meshSite = storedContext.meshSite
      state.sector = storedContext.sector
      state.periods = storedContext.periods
    }
  }
}

const actions = {}

const getters = {
  mode: state => state.mode,

  site: state => state.site,

  meshSite: state => state.meshSite,

  sector: state => state.sector,

  customer: state => state.customer,

  period: state => state.periods[state.mode],

  isValidContext: state => {
    switch (state.mode) {
      case ModeEnum.RELIABILITY:
        return state.site && state.sector && state.periods[state.mode]
      case ModeEnum.QUALITY:
        return state.site && state.customer && state.periods[state.mode]
      case ModeEnum.MESH_QUALITY:
        return state.site && state.meshSite && state.periods[state.mode]
      case ModeEnum.LEFTBEHIND:
        return state.site && state.periods[state.mode]
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
